import { render, staticRenderFns } from "./czkMealAdd.vue?vue&type=template&id=8251e5c0&scoped=true"
import script from "./czkMealAdd.vue?vue&type=script&lang=js"
export * from "./czkMealAdd.vue?vue&type=script&lang=js"
import style0 from "./czkMealAdd.vue?vue&type=style&index=0&id=8251e5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8251e5c0",
  null
  
)

export default component.exports